import React from "react";

import { connect } from "react-redux";
import {
  addToCart,
  updateTabValue,
  updateCartMetaData,
  updateProductData,
} from "../Redux/actions";

import DataNotFound from "../Util/DataNotFound/DataNotFound";
import SkeletonLoader from "../Util/SkeletonLoader/SkeletonLoader";
import Footer from "../Util/Footer/Footer";
import BaseUrl from "../Util/BaseUrl";
import ApiSuffix from "../Util/ApiSuffix";
import ProductImageLoader from "../Util/ImageLazyLoader/ProductImageLoader";
import Addons from "../Cart/Addons";

import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
// import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import RemoveRoundedIcon from "@material-ui/icons/RemoveRounded";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

import ReactGA from "react-ga";

import "./Product.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      fetchError: false,
      type: "mixed",
      eggType: "none",
      product: {},
      variants: [],
      selectedFlavor: "",
      selectedVariant: {},
      message: "",
      quantity: 1,
      polyPrice: 0,
      addedToCart: false,
      adding: false,
      openSnack: false,
      errorSnack: false,
      messageError: false,
      openDialog: false,
    };
    this.baseUrl = BaseUrl;
    this.apiSuffix = ApiSuffix;
    this.cakeFlavors = [
      "Pineapple",
      "Vanilla",
      "Black Forest",
      "Butterscotch",
      "Chocolate",
      "Strawberry",
      "Blueberry",
    ];
  }

  componentDidMount() {
    this.props.updateTabValue("/catalogue");
    let _prodName = this.props.match.params.prodName;
    this.pingAnaltyics("Product-" + _prodName);
    if (
      this.props.authStore.productCategoryData &&
      this.props.authStore.productCategoryData[_prodName]
    ) {
      let _data = this.props.authStore.productCategoryData[_prodName];
      this.setState({
        product: _data,
        loading: false,
      });
      if (_data.hasFlavours) {
        this.setState({ selectedFlavor: this.cakeFlavors[0] });
      }
      this.setProductContent(_data.productTags);
      this.checkEggVariants(_data.variants);
      this.sendSeoData(_data);
    } else this.getProductData();
  }

  getProductData = () => {
    this.setState({ loading: true });
    const url =
      this.baseUrl.dev +
      this.apiSuffix.productDetails +
      this.props.match.params.prodName +
      "/";
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        this.props.updateProductData(data);
        this.setState(
          {
            product: data,
            loading: false,
            fetchError: false,
          },
          () => {
            this.checkEggVariants(data.variants);
          }
        );
        if (data.hasFlavours) {
          this.setState({ selectedFlavor: this.cakeFlavors[0] });
        }
        this.setProductContent(data.productTags);
        this.sendSeoData(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ loading: false, fetchError: true });
      });
  };

  pingAnaltyics(data) {
    ReactGA.initialize("UA-162083606-1");
    ReactGA.pageview(data);
  }

  setProductContent = (tags) => {
    if (tags !== "hello") {
      document.getElementById("content").innerHTML = tags;
    }
  };

  sendSeoData = (data) => {
    document.title =
      "Shop | Buy " +
      data.productName +
      " | Online " +
      data.categoryName +
      " delivery in lucknow near me";
    let structuredData = JSON.stringify({
      "@context": "https://schema.org/",
      "@type": "Product",
      name: data.productName,
      image: [data.productImageURL],
      description: data.productDescription,
      sku: data.productCode,
      offers: {
        "@type": "Offer",
        url: window.location.href,
        priceCurrency: "INR",
        price: data.variants[0].productPrice,
        availability: "https://schema.org/InStock",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.7",
        reviewCount: "589",
      },
      brand: {
        "@type": "Brand",
        name: "Brijwasi Bakery",
        slogan: "Committed to Quality and Service since 1976.",
      },
    });
    let el = document.getElementById("brand-json");
    if (el) {
      el.remove();
    }
    let el2 = document.getElementById("product-json");
    if (el2) {
      el2.remove();
    }
    const script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.setAttribute("id", "product-json");
    script.textContent = structuredData;
    document.head.appendChild(script);
    let metaK = document.getElementsByName("keywords");
    metaK[0].content = data.productTags;
    let metaD = document.getElementsByName("description");
    metaD[0].content = data.productDescription;
  };

  checkCartforVariant = () => {
    this.setState({ addedToCart: false });
    this.props.cartStore.products.forEach((item) => {
      if (
        item.product.productDisplayURL ===
          this.state.product.productDisplayURL &&
        item.selectedVariant.id === this.state.selectedVariant.id
      ) {
        this.setState({ addedToCart: true, message: item.message });
      }
    });
  };

  checkEggVariants = (data) => {
    var eggfreeVar = this.filterVariants(data, "EggFree");
    var eggVar = this.filterVariants(data, "Egg");
    if (eggfreeVar && eggfreeVar.length === 0) {
      this.setState(
        {
          type: "pure-egg",
          eggType: "Egg",
          variants: eggVar,
          selectedVariant: eggVar[0],
        },
        () => {
          this.setDisplayPrice();
          this.checkCartforVariant();
        }
      );
    }
    if (eggVar && eggVar.length === 0) {
      this.setState(
        {
          type: "egg-free",
          eggType: "EggFree",
          variants: eggfreeVar,
          selectedVariant: eggfreeVar[0],
        },
        () => {
          this.setDisplayPrice();
          this.checkCartforVariant();
        }
      );
    }
    if (eggfreeVar && eggfreeVar.length > 0 && eggVar && eggVar.length > 0) {
      this.setState(
        {
          type: "mixed",
          eggType: "EggFree",
          variants: eggfreeVar,
          selectedVariant: eggfreeVar[0],
        },
        () => {
          this.setDisplayPrice();
          this.checkCartforVariant();
        }
      );
    }
    if (
      eggfreeVar &&
      eggfreeVar.length === 0 &&
      eggVar &&
      eggVar.length === 0
    ) {
      this.setState(
        {
          type: "none",
          eggType: "none",
          variants: data,
          selectedVariant: data[0],
        },
        () => {
          this.setDisplayPrice();
          this.checkCartforVariant();
        }
      );
    }
  };

  setDisplayPrice = () => {
    let displayPrice =
      this.state.selectedVariant.productPrice * this.state.quantity;
    this.setState({ polyPrice: displayPrice });
  };

  handleRadioChange = (event) => {
    this.setState({ eggType: event.target.value });
    let variants = this.filterVariants(
      this.state.product.variants,
      event.target.value
    );
    let dispPrice = this.state.quantity * variants[0].productPrice;
    this.setState(
      {
        variants: variants,
        selectedVariant: variants[0],
        polyPrice: dispPrice,
      },
      () => {
        this.checkCartforVariant();
      }
    );
  };

  filterVariants = (data, eggType) => {
    var filtered = data.filter((item) => {
      return item.productType === eggType;
    });
    return filtered;
  };

  handleVariantChange = (event) => {
    let displayPrice =
      JSON.parse(event.target.value).productPrice * this.state.quantity;
    this.setState(
      {
        selectedVariant: JSON.parse(event.target.value),
        polyPrice: displayPrice,
      },
      () => {
        this.checkCartforVariant();
      }
    );
  };

  handleFlavorChange = (event) => {
    this.setState({ selectedFlavor: event.target.value });
  };

  changeQuant = (action) => {
    let quant = this.state.quantity;
    if (action === "increase") {
      quant = quant + 1;
    } else {
      if (quant > 1) {
        quant = quant - 1;
      }
    }
    let dispPrice = this.state.selectedVariant.productPrice * quant;
    this.setState({ quantity: quant, polyPrice: dispPrice });
  };

  addToCart = () => {
    if (this.state.product.showMessage) {
      if (this.state.message.length > 0) {
        if (
          this.props.authStore.isAuthenticated &&
          this.props.authStore.userProfile.email
        ) {
          this.addToCartBackEnd();
        } else {
          this.addToCartFrontStore();
          this.pushToLocalStorage();
        }
      } else {
        this.setState({ errorSnack: true, messageError: true });
        if (document.getElementById("add-message")) {
          document
            .getElementById("add-message")
            .scrollIntoView({ behavior: "smooth" });
        }
      }
    } else {
      if (
        this.props.authStore.isAuthenticated &&
        this.props.authStore.userProfile.email
      ) {
        this.addToCartBackEnd();
      } else {
        this.addToCartFrontStore();
        this.pushToLocalStorage();
      }
    }
  };

  pushToLocalStorage = () => {
    let filter = {
      productName: this.state.product.productName,
      productImageURL: this.state.product.productImageURL,
      productCode: this.state.product.productCode,
      productDisplayURL: this.state.product.productDisplayURL,
      categoryDisplayURL: this.state.product.categoryDisplayURL,
      productDiscount: this.state.product.productDiscount,
    };
    const product = {
      product: filter,
      selectedVariant: this.state.selectedVariant,
      quantity: this.state.quantity,
      message: this.state.message,
      flavour: this.state.selectedFlavor,
    };
    let products = JSON.parse(localStorage.getItem("products"));
    if (products && products.length > 0) {
      products.push(product);
    } else {
      products = [product];
    }
    localStorage.setItem("products", JSON.stringify(products));
  };

  addToCartFrontStore = (id) => {
    let filter = {
      productName: this.state.product.productName,
      productImageURL: this.state.product.productImageURL,
      productCode: this.state.product.productCode,
      productDisplayURL: this.state.product.productDisplayURL,
      categoryDisplayURL: this.state.product.categoryDisplayURL,
      productDiscount: this.state.product.productDiscount,
    };
    const product = {
      id: id,
      product: filter,
      selectedVariant: this.state.selectedVariant,
      quantity: this.state.quantity,
      message: this.state.message,
      flavour: this.state.selectedFlavor,
    };
    this.props.addToCart(product);
    if (this.state.product.showMessage) {
      this.setState({ openDialog: true });
    } else {
      this.setState({ openSnack: true });
    }
    this.setState({ addedToCart: true });
  };

  addToCartBackEnd = () => {
    this.setState({ adding: true });
    const user = this.props.authStore.userProfile;
    const cartItem = {
      username: user.email,
      quantity: this.state.quantity,
      productDisplayURL: this.state.product.productDisplayURL,
      variantID: this.state.selectedVariant.id,
      message: this.state.message,
      flavour: this.state.selectedFlavor,
    };
    const url = this.baseUrl.dev + this.apiSuffix.addCartItem;
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.props.authStore.authToken,
      },
      body: JSON.stringify(cartItem),
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ adding: false });
        this.addToCartFrontStore(data.id);
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ adding: false });
      });
  };

  handleCloseSnack = () => {
    this.setState({ openSnack: false });
  };

  handleAddOnClose = () => {
    this.setState({ openDialog: false });
  };

  closeErrorSnack = () => {
    this.setState({ errorSnack: false });
  };

  goToCart = () => {
    const url = "/cart";
    this.props.history.push(url);
  };

  routeToCategory = () => {
    const url = "/category/" + this.state.product.categoryDisplayURL;
    this.props.history.push(url);
  };

  handleMessageChange = (e) => {
    this.setState({ message: e.target.value, messageError: false });
  };

  render = () => {
    return (
      <div className="base-container">
        {this.state.loading ? (
          <SkeletonLoader />
        ) : this.state.fetchError ? (
          <DataNotFound history={this.props.history} />
        ) : (
          <React.Fragment>
            <div className="product-top-header">
              <div className="prod-product-breadcrumbs">
                <div className="prod-relative-add">
                  <button
                    className="prod-transparent-btn"
                    onClick={(e) => this.routeToCategory()}
                  >
                    {this.state.product.categoryName}
                  </button>{" "}
                  {">"} {this.state.product.subCategoryName}
                </div>
                <div className="prod-product-code">
                  Product Code: <b>{this.state.product.productCode}</b>
                </div>
              </div>
              <hr style={{ margin: "10px 0px" }} />
            </div>
            <div className="prod-product-wrapper">
              <div className="prod-product-image">
                <ProductImageLoader
                  src={this.state.product.productImageURL}
                  alt={this.state.product.productName}
                />
                {/* {!this.props.authStore.isPhonePe ? (
                  <div className="prod-share-wrapper">
                    Share :
                    <IconButton onClick={this.shareToWhatsapp}>
                      <WhatsAppIcon />
                    </IconButton>
                  </div>
                ) : null} */}
              </div>
              <div className="prod-product-description">
                <h2 className="prod-product-name">
                  {this.state.product.productName}
                </h2>
                <div className="product-details-desktop-wrapper">
                  <h4 className="prod-product-details">
                    {this.state.product.productDescription}
                  </h4>
                  {this.state.product.ingredients &&
                  this.state.product.ingredients.length > 0 ? (
                    <div className="prod-product-ingredients">
                      <strong>Ingredients : </strong>
                      {this.state.product.ingredients}
                    </div>
                  ) : null}
                  {this.state.product.nutritionalInfo &&
                  this.state.product.nutritionalInfo.length > 0 ? (
                    <div className="prod-nutritional-info">
                      <table
                        style={{
                          margin: "auto",
                          border: "1px solid #888",
                          borderSpacing: "0px",
                        }}
                      >
                        <thead style={{ background: "#ffb300" }}>
                          <tr>
                            <th colSpan="2">
                              Nutritional Value per 100g (Approx)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.product.nutritionalInfo.map(
                            (nutSet, index) =>
                              this.state.eggType.toLowerCase() ===
                              nutSet.type.toLowerCase() ? (
                                <tr key={index}>
                                  <td>{nutSet.nutrient}</td>
                                  <td>{nutSet.value}</td>
                                </tr>
                              ) : null
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : null}
                </div>
                <div>
                  {this.state.product.outsideLucknowDelivery ? (
                    <div className="prod-pan-india">
                      Nationwide Delivery applicable
                    </div>
                  ) : null}
                  <div className="prod-variants-heading">
                    Choose your Variant
                  </div>
                  {this.state.type === "none" ? null : (
                    <RadioGroup
                      aria-label="Egg Type"
                      name="eggtype"
                      value={this.state.eggType}
                      onChange={(e) => this.handleRadioChange(e)}
                      className="prod-radio-wrapper"
                    >
                      {this.state.type === "egg-free" ||
                      this.state.type === "mixed" ? (
                        <FormControlLabel
                          value="EggFree"
                          control={
                            <Radio style={{ color: "rgb(0, 195, 65)" }} />
                          }
                          label={<div className="font-monst">Egg Free</div>}
                        />
                      ) : null}
                      {this.state.type === "pure-egg" ||
                      this.state.type === "mixed" ? (
                        <FormControlLabel
                          value="Egg"
                          control={<Radio color="primary" />}
                          label={<div className="font-monst">Egg</div>}
                        />
                      ) : null}
                    </RadioGroup>
                  )}
                  {this.state.product.hasFlavours ? (
                    <div>
                      <div style={{ margin: "10px 0px", fontWeight: "bold" }}>
                        Choose your Flavour
                      </div>
                      <FormControl variant="outlined">
                        <Select
                          labelId="flav-variants"
                          id="flavor-variants"
                          value={this.state.selectedFlavor}
                          onChange={(e) => this.handleFlavorChange(e)}
                        >
                          {this.cakeFlavors.map((item, index) => (
                            <MenuItem value={item} key={index}>
                              <div className="prod-menu-item">{item}</div>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  ) : null}
                  <div style={{ margin: "10px 0px", fontWeight: "bold" }}>
                    Select your Sub-Variant ({this.state.variants.length} option
                    available)
                  </div>
                  <RadioGroup
                    aria-label="Select Variant"
                    name="variant"
                    value={JSON.stringify(this.state.selectedVariant)}
                    onChange={(e) => this.handleVariantChange(e)}
                    className="prod-radio-wrapper"
                  >
                    {this.state.variants.map((item, index) => (
                      <FormControlLabel
                        key={index}
                        value={JSON.stringify(item)}
                        control={<Radio color="primary" />}
                        label={
                          <div className="font-monst">{item.productWeight}</div>
                        }
                      />
                    ))}
                  </RadioGroup>
                  <div style={{ marginTop: "5px" }}>
                    <div
                      style={{ display: "inline-block", fontWeight: "bold" }}
                    >
                      Quantitiy
                    </div>
                    <IconButton
                      className="prod-icon-btn"
                      aria-label="decrease"
                      size="medium"
                      onClick={(e) => this.changeQuant("decrease")}
                    >
                      <RemoveRoundedIcon fontSize="inherit" />
                    </IconButton>
                    <span style={{ margin: "5px" }}>{this.state.quantity}</span>
                    <IconButton
                      className="prod-icon-btn"
                      aria-label="increase"
                      size="medium"
                      onClick={(e) => this.changeQuant("increase")}
                    >
                      <AddRoundedIcon fontSize="inherit" />
                    </IconButton>
                  </div>
                </div>
                {this.state.product.showMessage ? (
                  <div>
                    <div className="add-message-header">Message on Cake</div>
                    <TextField
                      id="add-message"
                      placeholder="Congratulations/Happy Birthday/Happy Anniversary"
                      value={this.state.message}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      disabled={this.state.addedToCart}
                      onChange={(e) => this.handleMessageChange(e)}
                      error={this.state.messageError}
                      helperText={
                        this.state.messageError
                          ? "Please fill this field."
                          : null
                      }
                    />
                  </div>
                ) : null}
                <hr style={{ margin: "10px 0px" }} />
                <div className="prod-cart-wrapper">
                  {this.state.product.productDiscount ? (
                    <div style={{ textAlign: "center" }}>
                      <div style={{ textDecoration: "line-through" }}>
                        MRP : Rs.
                        <span>{this.state.polyPrice}</span>
                      </div>
                      <div style={{ fontSize: "1.4rem", fontWeight: "bold" }}>
                        <b>(-{this.state.product.productDiscount} %) </b>
                        Rs.{" "}
                        {Math.ceil(
                          this.state.polyPrice *
                            (100 - this.state.product.productDiscount) *
                            0.01
                        )}
                        <div style={{ fontSize: "0.8rem" }}>
                          (incl. all taxes)
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="prod-price-tag">
                      MRP : Rs. {this.state.polyPrice}
                      <div style={{ fontSize: "0.8rem" }}>
                        (incl. all taxes)
                      </div>
                    </div>
                  )}
                  {this.state.product.isOutOfStock ? (
                    <div style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      Out of Stock
                    </div>
                  ) : (
                    <div>
                      {this.state.addedToCart ? (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={(e) => {
                            this.goToCart();
                          }}
                          startIcon={<ShoppingCartIcon />}
                        >
                          <div className="font-monst-bold">Go to Cart</div>
                        </Button>
                      ) : this.state.adding ? (
                        <CircularProgress />
                      ) : (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={(e) => {
                            this.addToCart();
                          }}
                          startIcon={<ShoppingCartIcon />}
                        >
                          <div className="font-monst-bold">Add to Cart</div>
                        </Button>
                      )}
                    </div>
                  )}
                </div>
                <hr style={{ margin: "10px 0px" }} />
                <div className="product-details-mobile-wrapper">
                  <h4 className="prod-product-details">
                    {this.state.product.productDescription}
                  </h4>
                  {this.state.product.ingredients &&
                  this.state.product.ingredients.length > 0 ? (
                    <div className="prod-product-ingredients">
                      <strong>Ingredients : </strong>
                      {this.state.product.ingredients}
                    </div>
                  ) : null}
                  {this.state.product.nutritionalInfo &&
                  this.state.product.nutritionalInfo.length > 0 ? (
                    <div className="prod-nutritional-info">
                      <table
                        style={{
                          margin: "auto",
                          border: "1px solid #888",
                          borderSpacing: "0px",
                        }}
                      >
                        <thead style={{ background: "#ffb300" }}>
                          <tr>
                            <th colSpan="2">
                              Nutritional Value per 100g (Approx)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.product.nutritionalInfo.map(
                            (nutSet, index) =>
                              this.state.eggType.toLowerCase() ===
                              nutSet.type.toLowerCase() ? (
                                <tr key={index}>
                                  <td>{nutSet.nutrient}</td>
                                  <td>{nutSet.value}</td>
                                </tr>
                              ) : null
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            {this.state.product.productTags !== "hello" ? (
              <div>
                <hr />
                <div id="content"></div>
                <hr />
              </div>
            ) : null}
            <Snackbar
              open={this.state.openSnack}
              autoHideDuration={3000}
              onClose={this.handleCloseSnack}
            >
              <Alert onClose={this.handleCloseSnack} severity="success">
                {this.state.product.productName} successfully added to your
                cart.
              </Alert>
            </Snackbar>
            <Snackbar
              open={this.state.errorSnack}
              autoHideDuration={8000}
              onClose={this.closeErrorSnack}
            >
              <Alert onClose={this.closeErrorSnack} severity="error">
                Please add some message on Cake or else write no message.
              </Alert>
            </Snackbar>
            <Dialog
              open={this.state.openDialog}
              onClose={this.handleAddOnClose}
              aria-labelledby="form-dialog-title"
              className="lrd-dialog"
              maxWidth="xs"
              TransitionComponent={Transition}
            >
              <DialogTitle style={{ background: "#ffb300" }}>
                <span className="font-monst-bold">You may also Like</span>
              </DialogTitle>
              <DialogContent>
                <div>
                  <Addons
                    updateCartValue={this.props.updateCartMetaData}
                    closePopup={this.handleAddOnClose}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleAddOnClose}
                  color="primary"
                  variant="contained"
                >
                  <span className="font-monst-bold">Close</span>
                </Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>
        )}
        <Footer />
      </div>
    );
  };
}

const mapStateToProps = (state) => ({
  cartStore: state.cartStore,
  authStore: state.authStore,
});

const mapDispatchToProps = (dispatch) => ({
  addToCart: (product) => dispatch(addToCart(product)),
  updateTabValue: (tabValue) => dispatch(updateTabValue(tabValue)),
  updateCartMetaData: () => dispatch(updateCartMetaData()),
  updateProductData: (prodData) => dispatch(updateProductData(prodData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Product);
